// src/themes.js
// Watercolor-artist palette themes for Peaceful Oasis

export const themes = {
  sage: {
    primaryColor: "#5C7A5E",
    accentColor: "#3D5C40",
    backgroundColor: "#F5F2ED",
    textColor: "#2C3E2D",
    buttonTextColor: "#FFFFFF",
    secondaryColor: "#A8BFA9",
    primaryColorComplementary: "#5C7A5E",
    accentColorComplementary: "#7A5C3D",
    backgroundColorComplementary: "#F5F2ED",
    textColorComplementary: "#1A2B1B",
    buttonTextColorComplementary: "#FFFFFF",
    secondaryColorComplementary: "#BFA8A8",
  },
  "dusty-rose": {
    primaryColor: "#C4838A",
    accentColor: "#9E5D63",
    backgroundColor: "#FBF5F3",
    textColor: "#3D2325",
    buttonTextColor: "#FFFFFF",
    secondaryColor: "#E8B4B8",
    primaryColorComplementary: "#C4838A",
    accentColorComplementary: "#839EC4",
    backgroundColorComplementary: "#FBF5F3",
    textColorComplementary: "#1A0F10",
    buttonTextColorComplementary: "#FFFFFF",
    secondaryColorComplementary: "#B4C8E8",
  },
  ocean: {
    primaryColor: "#4A7D8E",
    accentColor: "#2C5F6E",
    backgroundColor: "#F0F5F7",
    textColor: "#1A3A42",
    buttonTextColor: "#FFFFFF",
    secondaryColor: "#94C5D0",
    primaryColorComplementary: "#4A7D8E",
    accentColorComplementary: "#8E614A",
    backgroundColorComplementary: "#F0F5F7",
    textColorComplementary: "#0D1E22",
    buttonTextColorComplementary: "#FFFFFF",
    secondaryColorComplementary: "#D0AD94",
  },
};
